function SpaceModel(BaseModel, SpaceService) {
    'ngInject';

    class Space extends BaseModel {

        $query(company) {
            return SpaceService.query(company);
        }
    }

    return Space;
}

/***
 * @ngdoc service
 * @name BB:Space
 *
 * @description
 * Representation of an Space Object
 */
angular
    .module('BB')
    .service('SpaceModel', SpaceModel);



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_models/space_model.service.js